import { Link, useParams } from "react-router-dom";
import ProfileCard from "./profile-card/ProfileCard";

export default function ProfileDetailPage({ details }) {
  const params = useParams();

  return (
    <>
      <div className="profile-detail-page-wrapper">
        <div className="edit-profile-btn-wrapper">
          <Link className="btn-all-white" to={`/my-profile/${params.id}/edit`}>
            Edit Profile
          </Link>
        </div>
        <ProfileCard details={{ ...details, id: params.id }} />
      </div>
    </>
  );
}
